import { PDFRaster } from "@nova/protobuf"
import { updatePDFRasterVisibility } from "features/entity-caching/pdf-rasters/thunks"
import { zoomToShowPoints } from "features/map/zoom/thunks"
import store from "integrations/redux/store"
import { selectLocalRasterById } from "plugins/PDFRaster/PDFRasterSlice"

export const togglePdfRasterVisibility = (entity: PDFRaster) => {
    const isVisible = selectLocalRasterById(entity.id)(store.getState())?.visible || false
    store.dispatch(updatePDFRasterVisibility({ id: entity.id, visible: !isVisible }))
}

export const zoomToPdfRaster = (entity: PDFRaster) => {
    store.dispatch(
        zoomToShowPoints({
            points: entity.corners.map((corner) => [corner.longitude, corner.latitude]),
        })
    )
}
